export enum SourceSection {
    AddToFavouritesButton = 200,
    AddToFavouritesAfterLikeQuestion = 201,
    DismissButton = 202,
    DismissModalAfterDislikeFeedback = 203,
    DismissModalAfterDislikeFeedbackClose = 204,
    RestoreButton = 205,
    PropertyDetailModalSidebar = 206,
    PropertyDetailMobileShowNumberButton = 207,
    OneClickLeadShowNumber = 208
}
export enum SourceSection {
    AddToFavouritesButton = 200,
    AddToFavouritesAfterLikeQuestion = 201,
    DismissButton = 202,
    DismissModalAfterDislikeFeedback = 203,
    DismissModalAfterDislikeFeedbackClose = 204,
    RestoreButton = 205,
    PropertyDetailModalSidebar = 206,
    PropertyDetailMobileShowNumberButton = 207,
    OneClickLeadShowNumber = 208
}
